import { useState, useEffect } from "react";
import axios from "axios";
import { Bookmark } from "lucide-react";
import { toast } from "sonner";
import API_BASE_URL from "../../config";

const _base = process.env.REACT_APP_BACKEND_URL || API_BASE_URL;
const API = _base.endsWith('/api') ? _base : `${_base}/api`;

export default function SaveButton({ post, user }) {
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.saved_posts && post) {
      setSaved(user.saved_posts.includes(post.id));
    }
  }, [user, post]);

  const handleSave = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!user || user === false) {
      toast.error("Please log in to save posts");
      return;
    }

    if (loading) return;

    // Optimistic Update
    const previousSaved = saved;
    setSaved(!previousSaved);
    setLoading(true);

    try {
      const token = localStorage.getItem("token");
      console.log("TOKEN:", token);
      const headers = token ? { 
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}` 
      } : {
        "Content-Type": "application/json"
      };
      const endpoint = previousSaved ? "unsave" : "save";
      const { data } = await axios.post(`${API}/posts/${post.id}/${endpoint}`, {}, { 
        withCredentials: true,
        headers 
      });
      setSaved(data.saved);
      toast.success(data.saved ? "Post saved" : "Post unsaved");
    } catch (err) {
      // Revert on error
      setSaved(previousSaved);
      toast.error("Failed to update save status");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleSave}
      disabled={loading}
      className={`flex items-center gap-1.5 transition-colors p-1.5 rounded-lg text-sm ${
        saved ? "text-[#3FAF7A] bg-[#3FAF7A]/10" : "text-[#5C6B64] hover:text-[#3FAF7A] hover:bg-[#3FAF7A]/10"
      }`}
      data-testid={`save-btn-${post.id}`}
      aria-label={saved ? "Unsave post" : "Save post"}
    >
      <Bookmark className={`w-4 h-4 ${saved ? "fill-current" : ""}`} strokeWidth={1.5} />
      <span>{saved ? "Saved" : "Save"}</span>
    </button>
  );
}
